import React from 'react'
import { useContentful } from '@pcln/contentful-components'
import useContent from '@/hooks/useContent'
import MediaCardComponent from '@/components/Promos/MediaCard/MediaCardComponent'
import CONTENT from './contentMediaCard'

export default function IncredibleTile({
  contentFulFieldID
}: {
  contentFulFieldID: 'incredibleTileMobile' | 'incredibleTile'
}) {
  const incredibleTilePromo: any = useContentful(contentFulFieldID)
  const promo = useContent(incredibleTilePromo)

  const hasContentfulData = promo != null
  const mediaCardContent = hasContentfulData ? promo : CONTENT

  return <MediaCardComponent content={mediaCardContent} />
}
